var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1182_7155)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1182_7155)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1182_7155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9355 20.9974H15.066M15.066 20.9974L21.0004 15.0625M15.066 20.9974L21.0004 26.9321",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 0.5625C32.2873 0.5625 41.4375 9.71268 41.4375 21C41.4375 32.2873 32.2873 41.4375 21 41.4375C9.71268 41.4375 0.5625 32.2873 0.5625 21C0.5625 9.71268 9.71268 0.5625 21 0.5625Z",
    stroke: "white",
    strokeWidth: 1.125
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1182_7155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "matrix(-1 0 0 1 42 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1182_7155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "matrix(-1 0 0 1 42 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1182_7155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "matrix(-1 0 0 1 42 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.51c2285a54e43722b83ea4742ca1e188.svg";
export { ForwardRef as ReactComponent };